import type { ComponentProps, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

const Input: FC<ComponentProps<'input'>> = ({ className, type = 'text', ...props }): ReactNode => {
    return (
        <input
            type={type}
            data-slot='input'
            className={cn(
                'h-12 w-full min-w-0 rounded-lg border border-input bg-card px-3.5 text-base text-foreground transition-colors placeholder:text-muted-foreground/75 hover:border-foreground/60 disabled:cursor-not-allowed disabled:opacity-55 aria-invalid:border-destructive',
                className
            )}
            {...props}
        />
    )
}

export { Input }
